// Unidades disponibles
export const UNITS = {
  VOLUME: [
    { value: 'ml', label: 'ml' },
    { value: 'L', label: 'L (liter)' },
    { value: 'Gallon', label: 'Gallon' },
    { value: 'fl oz', label: 'fl oz (fluid ounce)' }
  ],
  WEIGHT: [
    { value: 'g', label: 'g (gram)' },
    { value: 'kg', label: 'kg (kilogram)' },
    { value: 'lb', label: 'lb (pound)' },
    { value: 'oz', label: 'oz (ounce)' }
  ],
  COUNT: [
    { value: 'Each', label: 'Each' }
  ]
};

// Todas las unidades en un solo array
export const ALL_UNITS = [
  ...UNITS.VOLUME,
  ...UNITS.WEIGHT,
  ...UNITS.COUNT
];

// Tipos de contenedor
export const CONTAINER_TYPES = [
  { value: 'Bottle', label: 'Bottle' },
  { value: 'Keg', label: 'Keg' },
  { value: 'Can', label: 'Can' },
  { value: 'Bag', label: 'Bag' },
  { value: 'Box', label: 'Box' },
  { value: 'Carton', label: 'Carton' },
  { value: 'Each', label: 'Each' },
  { value: 'L (liter)', label: 'L (liter)' },
  { value: 'Gallon',   label: 'Gallon' },
  { value: 'kg',       label: 'kg' },
  { value: 'lb',       label: 'lb' },
  { value: 'oz',       label: 'oz' }
];